import { FilterOpenedEvent } from 'ag-grid-community';

export function enableFilterOptionTabFocus(
  event: FilterOpenedEvent,
  excludedColumnIds: string[] = [],
): void {
  const columnId =
    'getColId' in event.column ? event.column.getColId() : undefined;
  if (columnId && excludedColumnIds.includes(columnId)) {
    return;
  }

  const filterBody = event.eGui.querySelector<HTMLElement>(
    '.ag-filter-body-wrapper.ag-set-filter-body-wrapper',
  );
  if (!filterBody) {
    return;
  }

  filterBody.addEventListener(
    'keydown',
    (keyboardEvent) => {
      if (keyboardEvent.key === 'Tab') {
        filterBody
          .querySelectorAll<HTMLElement>('.ag-filter-virtual-list-item')
          .forEach((item) => {
            item.tabIndex = 0;
          });
        keyboardEvent.stopPropagation();
      }
    },
    true,
  );
}
